import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '#/shared/ui/dialog'

interface DeleteConversationsDialogProps {
  open: boolean
  count: number
  pending: boolean
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
}

/** Confirmation before bulk-deleting the selected conversations. */
export function DeleteConversationsDialog({
  open,
  count,
  pending,
  onConfirm,
  onOpenChange,
}: DeleteConversationsDialogProps) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-phone-surface=""
        className="top-1/2 max-w-sm -translate-y-1/2 gap-3 p-5"
      >
        <DialogTitle>
          {t('phonePanel.select.deleteTitle', { count })}
        </DialogTitle>
        <DialogDescription>
          {t('phonePanel.select.deleteBody', { count })}
        </DialogDescription>
        <div className="flex justify-end gap-2 pt-1">
          <DialogClose asChild>
            <Button type="button" variant="outline" size="sm">
              {t('phonePanel.select.cancel')}
            </Button>
          </DialogClose>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            disabled={pending}
            onClick={onConfirm}
          >
            {t('phonePanel.select.deleteConfirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
